export default {"src":"/_next/static/media/saltalt.089be9bd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};